import { createContext, useContext } from "react";

import { createCopilotStore } from "src/unifiedCopilot/context/store";

export type CopilotContextType = ReturnType<typeof createCopilotStore>;

export const CopilotContext = createContext<CopilotContextType | null>(null);

/**
 * @internal Shared by the copilot context hooks. Product teams integrate
 * through the hooks in src/unifiedCopilot/context/hooks.ts instead.
 */
export const useCopilotStore = (): CopilotContextType => {
  const store = useContext(CopilotContext);
  if (!store) {
    throw new Error("CopilotContext is not defined");
  }
  return store;
};
